export class ModalAlertMessage {
  constructor(public title: string,
              public message: string) {
  }
}
